import { render, staticRenderFns } from "./ed-modal-grade.vue?vue&type=template&id=c4701c30&scoped=true&"
import script from "./ed-modal-grade.ts?vue&type=script&lang=ts&"
export * from "./ed-modal-grade.ts?vue&type=script&lang=ts&"
import style0 from "./ed-modal-grade.scss?vue&type=style&index=0&id=c4701c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4701c30",
  null
  
)

export default component.exports